module.exports = __webpack_public_path__ + "static/media/twn_cover.af4cb4c5.svg";